import Api from 'comps/Api.js'
import LoadingAnimation from 'comps/LoadingAnimation.js'
import {useEffect} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import actions from 'redux/actionsAndReducers/apiData_Actions.js'

const ApiPage = (props) => {
    const reduxDispatch = useDispatch()
    const apiData = useSelector(store => store.apiData)

    const pathName = window.location.pathname.replace(/^\//g, '') // Remove initial slash.

    useEffect(() => {
        reduxDispatch(actions.fetchApiData(pathName))
    }, [reduxDispatch, pathName])

    const tryAgain = (
        <button type="button" className="btn btn-primary" onClick={(e)=>{ reduxDispatch(actions.fetchApiData(pathName)) } }>Try again</button>
    )

    const isFetching = () => {
        if(apiData.status === 'fetching') return true
        if(apiData.status === null && apiData.value===null && apiData.error===null) return true
    }

    if(isFetching()) return <LoadingAnimation textLoading="Loading documentation" animationChildrenContainerStyle={{height: '60vh'}}/>
    if(apiData.status !== 200 && apiData.error === null) return <LoadingAnimation inactive textLoading={<><p>{`Unable to load documentation ${typeof apiData.status === 'number' ? `(${apiData.status})` : ''}`}</p>{tryAgain}</>} animationChildrenContainerStyle={{height: '60vh'}}/>
    if(apiData.error !== null) return <LoadingAnimation inactive textLoading={<><p>{`Unable to connect to server`}</p>{tryAgain}</>} animationChildrenContainerStyle={{height: '60vh'}}/>
    return <Api {...apiData.value} pathName={pathName}/>
}

export default ApiPage

